import { AxiosInstance } from "axios";
import { apiTypeUrlBaseGet } from "../api_common";
import { API_TYPES } from "../api_constants";
import { axiosInstanceCreate } from "./axios_common";

const authUrlBase: string = apiTypeUrlBaseGet(API_TYPES.AUTH);

export const axiosAuth: AxiosInstance = axiosInstanceCreate(authUrlBase);
